import { OldEmitterConfig } from "pixi-particles";

export const fireworksColors = [
	{
		start: "#a6dfff",
		end: "#ffffff",
	},
	{
		start: "#a8ffff",
		end: "#ffffff",
	},
	{
		start: "#e4ffff",
		end: "#ffffff",
	},
	{
		start: "#a4d3fd",
		end: "#ffffff",
	},
	{
		start: "#87d3ff",
		end: "#ffffff",
	},
];

export const coinEmitterSpecificConfigs: [
	Partial<OldEmitterConfig>,
	Partial<OldEmitterConfig>
] = [
	{
		startRotation: {
			min: -80,
			max: 90,
		},
	},
	{
		startRotation: {
			min: 260,
			max: 90,
		},
	},
];

export const coinEmitterBaseConfig: OldEmitterConfig = {
	emit: false,
	autoUpdate: true,
	alpha: {
		start: 1,
		end: 1,
	},
	scale: {
		start: 0.2,
		end: 0.2,
		minimumScaleMultiplier: 1,
	},
	color: {
		start: "#ffffff",
		end: "#ffffff",
	},
	speed: {
		start: 0,
		end: 0,
		minimumSpeedMultiplier: 1,
	},
	acceleration: {
		x: 0,
		y: 600,
	},
	maxSpeed: 0,
	noRotation: false,
	rotationSpeed: {
		min: 0,
		max: 200,
	},
	lifetime: {
		min: 3,
		max: 5,
	},
	blendMode: "normal",
	frequency: 0.005,
	emitterLifetime: 11,
	maxParticles: 1000,
	pos: {
		x: 0,
		y: 0,
	},
	addAtBack: true,
	spawnType: "rect",
	spawnRect: {
		x: -30,
		y: -30,
		w: 60,
		h: 60,
	},
};

export const fireworksParticleEmitterConfig: OldEmitterConfig = {
	emit: false,
	autoUpdate: true,
	alpha: {
		start: 1,
		end: 0,
	},
	scale: {
		start: 1.5,
		end: 1,
		minimumScaleMultiplier: 0.5,
	},
	speed: {
		start: 700,
		end: 350,
		minimumSpeedMultiplier: 0.2,
	},
	acceleration: {
		x: 0,
		y: 0,
	},
	maxSpeed: 0,
	startRotation: {
		min: 0,
		max: 360,
	},
	noRotation: false,
	rotationSpeed: {
		min: 0,
		max: 200,
	},
	lifetime: {
		min: 0.15,
		max: 0.85,
	},
	blendMode: "normal",
	frequency: 0.0001,
	emitterLifetime: 0.15,
	maxParticles: 600,
	pos: {
		x: 0,
		y: 0,
	},
	addAtBack: true,
	spawnType: "point",
};
